<template>
    <div class="default-view-layout">
        <div class="title__container">
            <h1>{{title}}</h1>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            title: String
        }
    }
</script>

<style scoped lang="scss">
    .default-view-layout {
        position : relative;
    }

    .title__container {
        h1 {
            margin : 0 0 30px 0;
        }
    }

</style>